export default __webpack_public_path__ + "static/media/reports-11.b5860919.png";